import { WaterOffIcon } from './WaterOffIcon';

/**
 * author: Google
 * id 6C9777A0-967D-4242-91B2-E4D6B5596498
 * name water-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-off.svg
 * tags
 */
export const InkOffIcon = WaterOffIcon;
export default InkOffIcon